/**
 * TanStack Query hooks for `kyc-aml`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kycAmlQueryKeys,
	type CreateKycAmlBody,
	type ListKycAmlResponse,
	type KycAmlRow,
} from "./api";

export function useKycAmlList(): UseQueryResult<ListKycAmlResponse, Error> {
	return useQuery({
		queryKey: kycAmlQueryKeys.list(),
		queryFn: list,
	});
}

export function useKycAmlCreate(): UseMutationResult<KycAmlRow, Error, CreateKycAmlBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kycAmlQueryKeys.all });
		},
	});
}

export function useKycAmlDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kycAmlQueryKeys.all });
		},
	});
}
